<template>
  <v-dialog v-model="isOpen" width="800">
    <v-card>
      <v-card-title>
        <h2 class="heading">{{ $t('submitAdvanceDialogTitle') }}</h2>
      </v-card-title>
      <v-card-text>
        <i18n path="submitAdvanceDialogText" tag="p">
          <strong>{{ advance.title }}</strong>
        </i18n>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn text color="error" @click="close">{{ $t('Cancel') }}</v-btn>
        <v-btn data-testid="confirm-submit-button" text color="primary" @click="submit">
          {{ $t('submitAdvanceSubmit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { createLink } from '@/api/helpers'
import { api } from '@/api'
import get from 'lodash/get'

export default {
  name: 'AdvanceSubmitDialog',
  data() {
    return {
      isOpen: false,
      advance: {},
    }
  },
  methods: {
    async submit() {
      try {
        await api.post(createLink('advance/{id}/submit', { id: this.advance.id }))
        this.close()
        this.$emit('submitted')
        this.notifySuccess(this.$t('advanceCardSubmitSuccess'))
      } catch (error) {
        const nonFieldErrors = get(error, 'response.data.non_field_errors', []).join(' ')
        const messageDetail = get(error, 'response.data.detail', null)
        const messageToDisplay = messageDetail || nonFieldErrors

        this.notifyError(this.$t('SubmitAdvanceCardSubmitError', { message: messageToDisplay }))

        throw error
      }
    },
    close() {
      this.advance = {}
      this.isOpen = false
    },
    open(advance) {
      this.advance = advance
      this.isOpen = true
    },
  },
}
</script>
